import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useWebsocket } from '../../hooks/useWebsocket'
import { selectIsAuthenticated, selectIsAuthLoading } from '../../state/auth.slice'
import LoadingPage from '../ui/LoadingPage'

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isAuthLoading = useSelector(selectIsAuthLoading)
  useWebsocket()

  useEffect(() => {
    // If auth is still loading, don't redirect - let the loading screen show
    if (isAuthLoading) {
      return
    }

    // If not authenticated, redirect to auth
    if (!isAuthenticated) {
      navigate('/login', { replace: true })
    }
  }, [isAuthenticated, isAuthLoading, navigate])

  // If auth is still loading, show loading screen
  if (isAuthLoading) {
    return (
      <LoadingPage
        title="Verifying Authentication"
        subtitle="Please wait while we verify your credentials"
      />
    )
  }

  // If not authenticated, don't render children (will redirect)
  if (!isAuthenticated) {
    return null
  }

  // If authenticated, render children
  return children
}

export default ProtectedRoute
